<template lang="pug">
  .latvia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/latvia-min.png"
      )
      span {{ gettext('Латвия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Латвия - небольшое государство-республика, с населением более 1,9 млн человек, которое относится к группе балтийских стран. Латвия является членом Евро Союза на протяжении 14 лет.') }}
        p {{ gettext('Экономика Латвии и её соседок на данном этапе набирают курс стремительного развития, создаются новые вакансии. Уровень безработицы снижается с каждым годом, что свидетельствует о большой заинтересованности работодателей в трудовых кадрах.') }}
        p {{ gettext('Конечно, средняя месячная плата в Латвии ниже сравнительно с более развитыми странами. Но, при этом существует хорошая перспектива для работы и подальшей иммиграции для граждан других, менее развитых стран бывшего СНГ.') }}
        p {{ gettext('Латвийская экономика развивается в основном за счет сфер сельского хозяйства, лесной промышленности, индустрии и транспорта. Данные отрасли требуют постоянного наличия рабочих рук, которых в Латвии с каждым годом становится все меньше. Молодые латыши нацелены на трудоустройство в более развитых европейских странах, оставляя за собой сотни незакрытых вакансий. Поэтому востребованы как технические рабочие специалисты, строители так и водители грузовых автомобилей.') }}
        p {{ gettext('Латвию наши земляки выбирают из-за возможности исключить проблемы, возникающие с языковым барьером и непохожестью менталитета, ведь около 70% населения владеют русским языком, из которых третья часть - иммигрировавшие россияне. Еще одним немаловажным фактом является то, что согласно двустороннему соглашению Латвии с Украиной, Россией, Белоруссией, Сша и Канадой стаж, который заработали граждане этих стран, работая в Латвии, перечисляется в страну происхождения иностранца.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/latvia-min.png'})
  },
  name: 'Latvia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Latvia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/latvia/index.vue